import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { SiteText } from '../models/siteText';

@Injectable({
  providedIn: 'root'
})
export class SiteTextService {
  private readonly BASE_ETF_API: string = environment.baseEtfApi;

  constructor(private readonly http: HttpClient) {}

  public getSiteText(textCode: string): Observable<SiteText> {
    return this.http.get<SiteText>(`${this.BASE_ETF_API}/site-text/{textCode}?textCode=${textCode}`);
  }
}
